import { PlusOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import React from 'react';
import SharedAccordion from 'shared/components/Accordion';
import ScopeThreeHeader from 'shared/components/Scope3Header';
import ScopeThreeCategoryCard from 'shared/components/ScopeThreeCategoryCard';
import { ReactComponent as CategoryOne } from 'assets/icons/money_bag_cat_15.svg';
import COButton from 'shared/components/COButton';
import { ReactComponent as AddIcon } from 'assets/icons/add_enclosed.svg';
import { ButtonLabels } from 'enums/RawMaterialEnums';
import styles from '../appComponents.module.scss';

const ScopeThreeAppComponents = () => {
  const submitForm = () => {
    // Will add while integrating
  };

  const panelList = [
    {
      key: '1',
      header: (
        <div>
          <div>Ingredient</div>
          <div className={styles.addAction}>
            <COButton text>
              <AddIcon />
              {ButtonLabels.ADD_INGREDIENT}
            </COButton>
          </div>
        </div>
      ),
      content: <p>This is the content of Panel 1.</p>,
    },
    {
      key: '2',
      header: 'Panel 2',
      content: <p>This is the content of Panel 2.</p>,
    },
    {
      key: '3',
      header: 'Panel 3',
      content: <p>This is the content of Panel 3.</p>,
    },
  ];

  const statusList = [
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    undefined,
    undefined,
  ];

  const categoryBase = {
    icon: <CategoryOne />,
    name: 'Category 1',
    title: 'Purchased Goods And Services',
    subHeading:
      'Emissions from the production of goods and services acquired by the company.',
  };

  const categoriesList = statusList.map(status => ({
    ...categoryBase,
    status,
  }));
  return (
    <>
      <ScopeThreeHeader
        icon={<PlusOutlined />}
        title="Category 1- Purchased Goods And Services"
        year="Jan 2023 - Dec 2023"
        onSubmit={submitForm}
      />
      <SharedAccordion
        panels={panelList}
        defaultActiveKey={['1']}
        accordion={false}
        expandIconPosition={'end'}
      />
      <Row gutter={[60, 24]}>
        {categoriesList.map(categories => {
          const { icon, name, title, subHeading, status } = categories;
          return (
            <Col span={8} key={name}>
              <ScopeThreeCategoryCard
                icon={icon}
                name={name}
                title={title}
                subHeading={subHeading}
                status={status}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default ScopeThreeAppComponents;
